import React from 'react';
import { useIntl } from 'react-intl';

import { renderWithBreaks } from '@utils/translations';

const ReferralProgrammeTab = () => {
  const intl = useIntl();

  return (
    <div>
      {renderWithBreaks(intl.formatMessage({ id: 'Referral Programme introduction' }))}
      <ul>
        <li>{intl.formatMessage({ id: '“Parties” means Uniplaces, the Referring User and the Referred Friend;' })}</li>
        <li>
          {intl.formatMessage({ id: '“Party” means one of Uniplaces, the Referring User or the Referred Friend;' })}
        </li>
        <li>
          {intl.formatMessage({
            id: '“Referral Medium” has the meaning given to it in the section headed “How to Earn Referral Credit” below;'
          })}
        </li>
        <li>
          {intl.formatMessage({ id: '“Referred Friend” means the friend referred to Uniplaces by a Referring User;' })}
        </li>
        <li>
          {intl.formatMessage({
            id: '“Referring User” means a registered User who refers Uniplaces to their friends; and “Restrictions” means those restrictions contained in the section entitled “Restrictions”.'
          })}
        </li>
      </ul>
      <h3>{intl.formatMessage({ id: 'How to Earn Referral Credit'})}</h3>
      <p>
        {intl.formatMessage({
          id: 'After completing your registration through uniplaces.com, provided that none of the Restrictions apply, the Referring User will be provided with a referral promotional code (the “Referral Medium”) on the Personal Dashboard of their Uniplaces account.'
        })}
      </p>
      <p>{intl.formatMessage({ id: 'The Referring User can earn credit if:' })}</p>
      <ul>
        <li>{intl.formatMessage({ id: '(1) the Referring User has completed their register on uniplaces.com;' })}</li>
        <li>
          {intl.formatMessage({
            id: '(2) the Referred Friend creates a valid Uniplaces account that complies with the Uniplaces Terms of Service;'
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'and (3) the Referred Friend completes a Booking with the Referring User’s Referral Medium, which is accepted by the relevant Accommodation Provider, provided that none of the Restrictions apply. Each transaction that satisfies the above criteria will be a “Successful Referral”. Satisfaction of the above criteria will not prejudice Uniplaces’ rights under the paragraph entitled “Termination and Change” below. The Referring User will be credited an amount (a “Referral Credit”) for each Successful Referral equal to the amount described in the promotional materials which either accompany these terms or reference these terms. The Referring User has no limitation on the amount they can accrue per month.' })}
        </li>
      </ul>
      <h3>{intl.formatMessage({ id: 'Restrictions' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Restrictions text' }))}
      <h3>{intl.formatMessage({ id: 'Redeeming Referral Credit' })}</h3>
      {renderWithBreaks(
        intl.formatMessage({
          id: 'Referral Credits will automatically appear as an amount on the “Invite friends” section when the Referring User is logged in on uniplaces.com. The Referring User must provide valid bank account details in order to receive their accrued Referral Credits (their “Nominated Bank Account”). Uniplaces will not be liable if the Referring User provides incorrect Nominated Bank Account details. To redeem their Referral Credit, the Referring User must request it on their Personal Dashboard on uniplaces.com. The Referral Credit will be transferred to the Nominated Bank Account within thirty days from the date on which the Referral Credit is requested.'
        })
      )}
      <h3>{intl.formatMessage({ id: 'Referred Friend Discount' })}</h3>
      {renderWithBreaks(
        intl.formatMessage({
          id: 'The Referred Friend will receive a discount (a “Referral Discount”) toward its first Booking. The standard Referral Discount is 10% off the Uniplaces Fee, but may vary in some cases if the Referred Friend signed up as part of a special promotion. Discounts that differ from the standard and additional terms will be shown in the referral invitation or accompanying promotional materials.'
        })
      )}
      <h3>{intl.formatMessage({ id: 'Multiple Referral Medium' })}</h3>
      {renderWithBreaks(
        intl.formatMessage({
          id: 'The Referred Friend will only be able to use one Referral Medium. If the Referred Friend receives Referral Medium from registered Users other than the Referring User, the Referring User will only receive Referral Credit if the Referred Friend uses the Referring User’s Referral Medium before any other referral medium.'
        })
      )}
      <h3>{intl.formatMessage({ id: 'Relationship and Liability for Tax' })}</h3>
      {renderWithBreaks(
        intl.formatMessage({
          id: 'The Parties are independent contractors. Consequently, the provisions of These Terms will not, under any circumstances, be interpreted as creating any association, relationship of agency, employment or partnership between the Parties. Neither Party may bind any other in any manner whatsoever or in favour of anyone whomsoever, except in accordance with These Terms.'
        })
      )}
      <h3>{intl.formatMessage({ id: 'Termination and Change' })}</h3>
      {renderWithBreaks(
        intl.formatMessage({
          id: 'Uniplaces may suspend or terminate the Referral Programme, or the Referring User’s or Referred Friend’s ability to participate in the Referral Programme, at any time, for any reason or no reason, and without providing the Referring User or Referred Friend (as the case may be) with its reasoning. Uniplaces reserves the right to review and investigate all Successful Referrals for fraudulent activity, and acting reasonably:'
        })
      )}
      <ul>
        <li>
          {intl.formatMessage({
            id: '(1) to suspend the Referring User or the Referred Friend from the Referral Programme;'
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: '(2) modify or remove Referral Credits granted in respect of a Successful Referral;'
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'and (3) modify, remove or require payment of the Referral Discount granted in respect of a Successful Referral, where fraudulent activity is, in Uniplaces\' reasonable opinion, found.'
          })}
        </li>
      </ul>
      <p>
        {intl.formatMessage({
          id: 'The Referring User and the Referred Friend acknowledge that, without prejudice to the generality of the foregoing, breach by either the Referring User or the Referred Friend (as applicable) of any of the Restrictions will be deemed fraudulent activity by Uniplaces.'
        })}
      </p>
      <h3>{intl.formatMessage({ id: 'Updates to the Terms' })}</h3>
      <p>
        {intl.formatMessage({
          id: 'Uniplaces can update These Terms at any time without prior notice. If Uniplaces modifies These Terms, Uniplaces will post the modification on the Uniplaces.com website. Continued participation in the Referral Programme by the Referring User or Referred Friend after any modification will constitute consent to such modification.'
        })}
      </p>
    </div>
  );
}

export default ReferralProgrammeTab;
